ui-cms-headline {
  display: block;

  .heading {
    margin: 0;
    gap: $sd-spacing-4;

    > .sd-headline {
      sd-icon {
        margin-top: 0;
      }
    }
  }

  // necessary to achieve higher specificity
  .sd-headline--size-xl.sd-headline--size-xl {
    color: $sd-textColor-primary-DEFAULT;
  }

  .overline {
    display: block;
    font-weight: $sd-fontWeight-bold;
    margin-bottom: $sd-spacing-2;
    color: $sd-textColor-primary-DEFAULT;

    &--inverted {
      color: $sd-textColor-white;
    }
  }

  &.centered {
    display: block;
    width: 100%;
    text-align: center;
  }

  .leadtext {
    margin-top: $sd-spacing-3;
  }
}
